import type { FaireProductEntity } from "../../entity_types/product";

export const p_9npkq5h6ze: FaireProductEntity = {
  token: "p_9npkq5h6ze",
  type: "product",
  name: "Brown Bandana Fringe Vest",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/35a65d0532feb71ba3dc0e088e891a313e31849f178915931050aebec962a011.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5a55cb54feba11760d6fa7529d502c412bf918eab6d15c857c7149bccc5b753e.jpeg",
    "https://cdn.faire.com/fastly/f1d685deab84ba05712f29995d6c78351ec45ed53c0a76721601961fa8c82d79.jpeg",
    "https://cdn.faire.com/fastly/6a013751d117721c2b4d5fce9fd8685715ea75cbfb8a6aa9ff51d9bc3fcbcffe.jpeg",
    "https://cdn.faire.com/fastly/19dc7bd8ef990de87dbb08a8db6c3c160f7476556509fc9934b518a1851ae03f.jpeg"
  ],
  priceDollars: 33.95,
  description: "Brown Bandana Fringe Vest featuring an allover black bandana-inspired pattern, designed with an open front, self-tie waist closure, two front pockets, sleeveless silhouette, and long fringe trim along the front and hem. Finished in a soft knit fabric with a relaxed fit for easy western-inspired layering.\n\n39% Acrylic, 31% Polyester, 30% Polyamide\n\nPre-pack 1-2-2-2-1 (XS-XL)\n\nMin. Qty: 8",
  tags: [],
  msrpDollars: 84.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:53.498Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
